<template>
    <div>
        <Loader :loader="loader" />
        <b-alert :show="keyResults.length == 0 && !loader" class="m-0 mb-3">
            <span>{{ $t('isEmptyAlert') }}</span>
        </b-alert>
        <b-container fluid tag="b-media-body" class="p-0" v-if="keyResults.length">
            <label class="mb-2">{{ $t('okr.editKeyResults') }}</label>
            <b-row no-gutters align-v="center" class="mb-1" v-for="keyResult in keyResults" :key="keyResult.id">
                <b-col cols="12" class="border rounded p-2 mb-1">
                    <div class="d-flex">
                        <div class="mr-auto mb-1">
                            {{ keyResult.title }}
                        </div>
                        <div>
                            <a href="#" @click.prevent="editKeyResult(keyResult.id)">
                                <i class="icon-note font-weight-bold"></i>
                            </a>
                        </div>
                    </div>
                    <b-row no-gutters align-v="center" class="d-flex">
                        <div class="mr-auto w-100">
                            <b-form-group
                                :label="$t('form.label.name')"
                                class="mb-1"
                                v-if="editingKeyResult === keyResult.id"
                            >
                                <b-form-input
                                    v-if="editingKeyResult === keyResult.id"
                                    type="text"
                                    v-model="keyResult.title"
                                />
                            </b-form-group>
                        </div>
                    </b-row>
                    <b-row>
                        <b-col cols="12" class="d-flex mt-2" v-if="editingKeyResult === keyResult.id">
                            <div class="mr-auto">
                                <b-form-group :label="$t('form.label.initialValue')" class="mb-1">
                                    <b-form-input type="number" v-model="keyResult.start_value" />
                                </b-form-group>
                            </div>

                            <div>
                                <b-form-group :label="$t('feed.fields.target_value')" class="mb-1">
                                    <b-form-input type="number" v-model="keyResult.target_value" />
                                </b-form-group>
                            </div>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>
        <div class="footer d-flex justify-content-end mt-3">
            <b-button class="mr-2" variant="outline-primary" :disabled="isSubmitting" @click="onClickCancel">{{
                $t('form.button.cancel')
            }}</b-button>
            <b-button v-if="editingKeyResult !== null" variant="primary" @click="saveKeyResult(editingKeyResult)">{{
                $t('form.button.apply')
            }}</b-button>
            <button-loader
                v-if="editingKeyResult === null"
                variant="primary"
                :disabled="isSubmitting"
                :loader="isSubmitting"
                @click="onClickSubmit"
            >
                {{ keyResults.length != 0 ? $t('form.button.save') : $t('form.button.duplicate') }}
            </button-loader>
        </div>
    </div>
</template>

<script>
import ButtonLoader from '@/views/components/button-loader'
import Loader from '@/views/components/loader'

export default {
    name: 'EditKeyResults',
    components: {
        ButtonLoader,
        Loader,
    },
    props: {
        keyResults: {
            type: Array,
            default: () => {
                return []
            },
        },
        isSubmitting: {
            type: Boolean,
            required: true,
        },
        loader: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            editingKeyResult: null,
        }
    },
    methods: {
        onClickSubmit() {
            this.$emit('submit')
        },
        onClickCancel() {
            this.$emit('cancel')
        },
        editKeyResult(id) {
            this.editingKeyResult === id ? (this.editingKeyResult = null) : (this.editingKeyResult = id)
        },
        saveKeyResult() {
            this.editingKeyResult = null
            this.$emit('key-result-updated', Object.values(this.keyResults))
        },
    },
    i18n: {
        messages: {
            'en-US': {
                isEmptyAlert: 'This OKR does not have key results.',
            },
            'es-ES': {
                isEmptyAlert: 'Este OKR no tiene resultados clave.',
            },
            'pt-BR': {
                isEmptyAlert: 'Esse OKR não possui resultados chave.',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
.w-90 {
    width: 95%;
}
</style>
